import { UseFormProps, useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

export function useZodForm<
    TSchema extends z.ZodType,
    TIgnoreTransformedValues extends 'ignoreTransformedValues' | undefined = undefined,
>(
    props: Omit<UseFormProps<TSchema['_input']>, 'resolver'> & {
        schema: TSchema;
    }
) {
    return useForm<
        TSchema['_input'],
        any,
        // `undefined` used to make react-hook-form fall back to the field values, but since v7.55
        // the transformed values are no longer conditional, so we have to name the input type.
        TIgnoreTransformedValues extends 'ignoreTransformedValues' ? TSchema['_input'] : TSchema['_output']
    >({
        ...props,
        resolver: zodResolver(props.schema, undefined),
    });
}
